const toTitleCase = (str) => {
  const _str = str.replace('_', ' ');
  return _str.replace(/\w\S*/g, function (txt) {
    return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
  });
};

export default toTitleCase;
